export type SmsLineMessage = {
  messenger?: string
  messenger_type?: string
  direction?: string
  metadata?: Record<string, unknown>
}

function text(value: unknown): string {
  return typeof value === 'string' ? value.trim() : ''
}

function looksLikePhone(value: string): boolean {
  return value.replace(/\D/g, '').length >= 10
}

export function smsLinePhone(message: SmsLineMessage): string {
  const channel = `${message.messenger ?? ''} ${message.messenger_type ?? ''}`.toLowerCase()
  if (!channel.includes('sms')) return ''
  const meta = message.metadata ?? {}
  const explicit = text(meta.line_phone)
  if (looksLikePhone(explicit)) return explicit
  const candidate = message.direction === 'outgoing' ? text(meta.sender_phone) : text(meta.recipient_phone)
  return looksLikePhone(candidate) ? candidate : ''
}

export function formatLinePhone(raw: string): string {
  const digits = raw.replace(/\D/g, '')
  const local = digits.length === 11 ? digits.slice(1) : digits
  if (local.length === 10) {
    return `+7 ${local.slice(0, 3)} ${local.slice(3, 6)}-${local.slice(6, 8)}-${local.slice(8)}`
  }
  return raw
}
